import "./Media.module.css";
import Header from "@/reusable_sections/Header";
import MediaGalleryHero from "./sections/MediaGalleryHero";
import VideoGallery from "./sections/VideoGallery";
import AudioPlayer from "./sections/AudioPlayer";
import MediaArchive from "./sections/MediaArchive";
import TravelHeader from "./sections/TravelHeader";
import TravelHeaderCopy from "./sections/TravelHeaderCopy";
import DonationMemorial from "./sections/DonationMemorial";
import Footer from "@/reusable_sections/Footer";
export default function MediaPage() {
  return <div>
      <Header />
      <TravelHeader />
      <TravelHeaderCopy />
      <MediaGalleryHero />
      <VideoGallery />
      <AudioPlayer />
      <MediaArchive />
      <DonationMemorial />
      <Footer />
    </div>;
}